import React, {Component} from "react";
import axios from 'axios';
import $ from "jquery";

export default class AccountStateAct extends Component {

    constructor() {
        super(...arguments);
        let errors = this.props.errors ? JSON.parse(this.props.errors) : {};

        this.state = {
            'user': JSON.parse(this.props.user),
            'errors': errors,
            'checked': false,
            'checkedArr': [],
            'actBeginDate': '',
            'show': true
        };

        this.preloader = this.preloader.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
    }

    preloader(e) {
        let checkedArr = this.state.checkedArr;
        e.preventDefault();
        if (checkedArr.length < 4) {
            $('.reconciliation-error').attr('hidden', false);
        } else {
            $('.reconciliation-error').attr('hidden', true);
            window.open(this.props.pdfreconsiliationlink);
        }
    }

    handleCheck(e){
        let checkedArr = this.state.checkedArr;
        this.setState({
            checked: e.target.checked
        });
        if (e.target.checked && checkedArr.indexOf(e.target.name) == -1) {
            checkedArr.push(e.target.name)
        } else {
            checkedArr.splice( checkedArr.indexOf(e.target.name), 1 );
        }

        this.setState({checkedArr});
    }

    render() {
        return (
            <div className="w-100">
                {this.state.show &&
                <div>
                    {this.state.actBeginDate || this.state.message ?
                        this.state.actBeginDate ?
                            <div className="col-md-12">
                                <p className="text-center py-5">
                                    Довiдка про стан рахунку формується один раз на місяць.<br/>
                                    {this.state.actBeginDate} Ви вже сформували довiдку про стан рахунку.<br/>
                                    Зверніться, будь ласка, в наступному місяці.
                                </p>
                            </div>
                            :
                            <div className="col-md-12">
                                <p className="text-center py-5">
                                    {this.state.message}
                                </p>
                            </div>
                        :
                        <div className="col-md-12">
                            <div className="custom-control form-group custom-checkbox ">
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="reconciliation1"
                                    name="reconciliation1"
                                    required={true}
                                    onChange={this.handleCheck}
                                    value={this.state.checked}
                                />
                                <label htmlFor="reconciliation1" className="custom-control-label">
                                    Я підтверджую, що всі <strong>платежі</strong> враховані
                                </label>
                            </div>

                            <div className="custom-control form-group custom-checkbox ">
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="reconciliation2"
                                    name="reconciliation2"
                                    required={true}
                                    onChange={this.handleCheck}
                                    value={this.state.checked}
                                />
                                <label htmlFor="reconciliation2" className="custom-control-label">
                                    Я згоден(на) з поточною сумою <strong>заборгованості</strong> (або переплати)
                                </label>
                            </div>

                            <div className="custom-control form-group custom-checkbox ">
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="reconciliation3"
                                    name="reconciliation3"
                                    required={true}
                                    onChange={this.handleCheck}
                                    value={this.state.checked}
                                />
                                <label htmlFor="reconciliation3" className="custom-control-label">
                                    Я розумію, що <strong>довідка може бути скасована Постачальником</strong> послуги,
                                    якщо дані в Довідці
                                    не відповідатимуть дійсності або будуть виявлені нові відомості,
                                    що суперечитимуть зазначеним в довідці.
                                </label>
                            </div>

                            <div className="custom-control form-group custom-checkbox ">
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="reconciliation4"
                                    name="reconciliation4"
                                    required={true}
                                    onChange={this.handleCheck}
                                    value={this.state.checked}
                                />
                                <label htmlFor="reconciliation4" className="custom-control-label">
                                    <strong>Я звірив(ла) всю інформацію по особовому рахунку, повністю з нею
                                        згоден(на) і
                                        готовий(а) підтвердити цей факт формуванням довідки про стан
                                        рахунку</strong>
                                </label>
                            </div>

                            <div className="reconciliation-error" hidden>
                                <p className="text-danger">Для створення довідки про стан рахунку Ви повинні підтвердити
                                    кожен пункт форми</p>
                            </div>

                            <div className="d-flex justify-content-end mt-2">
                                <button type="button" id="btn-reconciliation" className="btn btn-primary" onClick={this.preloader}>
                                    Сформувати
                                </button>
                            </div>
                        </div>
                    }
                </div>
                }
            </div>
        );
    }
}
